import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ResultsLayer from "../components/ResultsLayer";

const ResultsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Exam Results" />

        {/* ResultsLayer */}
        <ResultsLayer />
      </MasterLayout>
    </>
  );
};

export default ResultsPage;
